import React from 'react';
import logo from '../assets/logo-ventec.png';

const Logo = () => {
  return (
    <div className="p-4 flex justify-center items-center">
      <img src={logo} alt="Ventec Énergie Logo" style={{ maxWidth: '200px', height: 'auto' }} />
    </div>
  );
};

export default Logo; 